import React from 'react';
import { ComponentWithAs, Flex, FlexProps, forwardRef, Heading } from '@chakra-ui/react';
import RecommendationCount from '../molecule/RecommendationCount';

const HomeTitleSection: ComponentWithAs<'div', FlexProps> = forwardRef<FlexProps, 'div'>((props, ref) => {
  return (
    <Flex direction='column' align='center' justify='center' height='100%' ref={ref} {...props}>
      <Heading fontWeight={'300'}>숨쉴때</Heading>
      <Heading>뭐먹지</Heading>
      <RecommendationCount />
    </Flex>
  );
});

export default HomeTitleSection;
